<template>
    <div class="overlay">
        <transition :name="overlay.transition"
                @enter="onScrollLockEnterHook"
                @afterLeave="onScrollLockAfterLeaveHook">
            <div class="overlay--root" v-if="overlay.isOpen">
                <div class="overlay--backdrop"></div>
                <div class="overlay--display">
                    <div class="overlay--wrap-outer">
                        <div class="overlay--wrap-inner">
                            <div class="overlay--backdrop-click-area" @click.prevent="closeOverlay"></div>
                            <div class="overlay--container">
                                <div class="overlay--revealer">
                                    <cmp-modal :facet="overlay.facet">
                                        <component :is="overlay.component" v-bind="overlay.props"></component>
                                    </cmp-modal>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import scrollLockHelperMixin from 'vue/mixins/scroll-lock-helper';


    export default {
        mixins: [
            scrollLockHelperMixin,
        ],
        computed: {
            ...mapGetters(['overlay']),
        },
        methods: {
            ...mapActions(['closeOverlay']),
            onEscapePressed: function(e) {
                // NOTE: Don't respond to key presses, when there is an active element
                if (document.activeElement && document.activeElement !== document.body) {
                    return;
                }

                if (e.keyCode === 27 && this.overlay.isOpen) {
                    this.closeOverlay({});
                }
            },
        },
        created: function() {
            document.addEventListener('keyup', this.onEscapePressed);
        },
        destroyed: function() {
            document.removeEventListener('keyup', this.onEscapePressed);
        },
    };
</script>



// WEBPACK FOOTER //
// index.vue?56307335